import { onCLS, onFCP, onINP, onLCP, onTTFB, Metric } from 'web-vitals';
import { createFileLogger } from './utils/logger';

const log = createFileLogger('WEB_VITALS');

// Web Vitals reporting function
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    try {
      // Collect all Core Web Vitals
      onCLS(onPerfEntry);
      onINP(onPerfEntry); // FID has been replaced with INP (Interaction to Next Paint) in v5.x
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
      
      log.debug('Web Vitals monitoring initialized');
    } catch (error) {
      log.error('Failed to initialize Web Vitals:', error);
    }
  } else {
    // Default behavior - log metrics to console in development
    if (process.env.NODE_ENV === 'development') {
      const logMetric = (metric: Metric) => {
        log.info(`Web Vital - ${metric.name}:`, {
          value: metric.value,
          delta: metric.delta,
          id: metric.id
        });
      };
      
      try {
        onCLS(logMetric);
        onINP(logMetric); // FID has been replaced with INP (Interaction to Next Paint) in v5.x
        onFCP(logMetric);
        onLCP(logMetric);
        onTTFB(logMetric);
      } catch (error) {
        log.error('Failed to collect Web Vitals:', error);
      }
    }
  }
};

// Support both named and default exports for compatibility
export { reportWebVitals };
export default reportWebVitals;